function debounce(callback, delay) {
  let timeoutId;

  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => callback(...args), delay);
  };
}

function getVisibleHeight(element) {
  if (!element) return 0;

  const styles = window.getComputedStyle(element);

  if (styles.display === 'none' || styles.visibility === 'hidden') return 0;

  return Math.round(element.getBoundingClientRect().height);
}

function isHomepageOverlayHeader(header) {
  if (!header) return false;

  if (!document.body.classList.contains('template-index')) return false;

  return header.dataset.headerOverlay === 'true';
}

function setHeaderOffset() {
  const announcement = document.querySelector('[data-site-announcement]');
  const header = document.querySelector('[data-site-header]');

  const announcementHeight = getVisibleHeight(announcement);
  const headerHeight = getVisibleHeight(header);
  const totalOffset = isHomepageOverlayHeader(header) ? 0 : announcementHeight + headerHeight;

  document.body.style.setProperty('--site-announcement-offset', `${announcementHeight}px`);
  document.body.style.setProperty('--site-header-offset', `${headerHeight}px`);
  document.body.style.setProperty('--site-total-header-offset', `${totalOffset}px`);
}

const scheduleHeaderOffset = debounce(setHeaderOffset, 50);

window.addEventListener('load', scheduleHeaderOffset);
window.addEventListener('resize', scheduleHeaderOffset);
document.addEventListener('DOMContentLoaded', scheduleHeaderOffset);
document.addEventListener('shopify:section:load', scheduleHeaderOffset);
document.addEventListener('shopify:section:reorder', scheduleHeaderOffset);
document.addEventListener('shopify:section:select', scheduleHeaderOffset);
document.addEventListener('shopify:section:deselect', scheduleHeaderOffset);

window.setTimeout(setHeaderOffset, 0);
window.setTimeout(setHeaderOffset, 250);
